import env from "./env";
import { getUrlParam } from "./util";
var customPfKey = 'vftpf';
// 会员统一平台号
// 即将废弃，后续会员后台统一使用视频平台号
export var VIP_PLATFORM = {
  h5: 1,
  web: 2,
  aphone: 8,
  iphone: 7,
  apad: 6,
  ipad: 5,
  tv: 10,
  windows: 16,
  mac: 18
};

// 视频统一平台号
export var VIDEO_PLATFORM = {
  h5: 3000,
  web: 2,
  aphone: 3,
  ipad: 4,
  iphone: 5,
  apad: 6,
  tv: 8,
  wxminiapp: 9,
  windows: 16,
  mac: 18
};

// 数据侧使用平台号
export var AID_PLATFORM = {
  web: 1000,
  h5: 3000,
  app: {
    aphone: 8,
    iphone: 7,
    apad: 6,
    ipad: 5,
    windows: 2000,
    mac: 2001
  },
  liteapp: {
    aphone: 23,
    iphone: 24
  },
  kidapp: {
    aphone: 8003,
    iphone: 8004,
    apad: 8006,
    ipad: 8005
  },
  mqq: {
    aphone: 8001,
    iphone: 8002
  },
  weishi: {
    aphone: 32,
    iphone: 31
  },
  qqnews: {
    aphone: 35,
    iphone: 36,
    ipad: 58
  },
  qqbrowser: {
    aphone: 34,
    iphone: 33
  },
  qqmusic: {
    aphone: 38,
    iphone: 37
  },
  qqsports: {
    aphone: 9001,
    iphone: 9002,
    web: 9003,
    h5: 9004,
    ipad: 9005
  },
  accomic: {
    aphone: 42,
    iphone: 41,
    apad: 46,
    ipad: 45
  },
  mlol: {
    aphone: 43,
    iphone: 44
  },
  sogoumse: {
    aphone: 48,
    iphone: 47
  },
  wzyd: {
    aphone: 50,
    iphone: 51
  },
  ymzx: {
    aphone: 60,
    iphone: 59
  }
};
export function getAIDPlatform() {
  // 针对web的内容分发场景支持自定义传pf值
  var customPf = getUrlParam(customPfKey);
  if (customPf) return customPf;
  if (AID_PLATFORM[env.app] && AID_PLATFORM[env.app][env.device]) {
    return AID_PLATFORM[env.app][env.device];
  }
  return env.isWeb ? AID_PLATFORM.web : AID_PLATFORM.h5;
}
export function getVipPlatform() {
  return calculatePlatform(VIP_PLATFORM);
}
export function getVideoPlatform() {
  return calculatePlatform(VIDEO_PLATFORM);
}
function calculatePlatform(config) {
  var customPf = getUrlParam(customPfKey);
  if (customPf) return customPf;
  if (env.isApp || env.isTenvideoUnion || env.isMqq || env.isQQSports) {
    if (env.isIpad && (env.isUNApp || env.isTenvideoUnion)) {
      // iPad UN版或内容分发端，需要使用iPhone端的平台号
      return config.iphone;
    }
    if (config[env.device]) {
      return config[env.device];
    }
  }
  return env.isWeb ? config.web : config.h5;
}